export const GET_COMPANIES_SEARCH = 'app/Companies/GET_COMPANIES_SEARCH';
export const GET_COMPANIES_BY_SLUG = 'app/Companies/GET_COMPANIES_BY_SLUG';
export const GET_COMPANIES_COUNTRIES = 'app/Companies/GET_COMPANIES_COUNTRIES';
export const GET_COMPANIES_PRODUCTIONS = 'app/Companies/GET_COMPANIES_PRODUCTIONS';
export const CLEAR_COMPANIES_OPTIONS = 'app/Companies/CLEAR_COMPANIES_OPTIONS';
